import { IHAChangePollingCandidate } from '../interfaces/IHAChangePollingCandidate';
import { IHAStaticCandidate } from '../interfaces/IHAStaticCandidate';

export class PollingCandidateCount {

  private readonly _haChangePollingCandidate: IHAChangePollingCandidate;
  private readonly _haStaticCandidate: IHAStaticCandidate;

  constructor(haChangePollingCandidate: IHAChangePollingCandidate, haStaticCandidate: IHAStaticCandidate) {
      this._haChangePollingCandidate = haChangePollingCandidate;
      this._haStaticCandidate = haStaticCandidate;
  }

  public afterInit(): void {
    // calc totals here


  }

  public get partyId(): string {
    return this._haStaticCandidate.partyId;
  }

  public get partyName(): string {
    return this._haStaticCandidate.partyName;
  }

  public get colourCode(): string {
    return this._haStaticCandidate.colourCode;
  }

  public get gender(): string {
    return this._haStaticCandidate.gender;
  }

  public get candidateName(): string {
    return this._haStaticCandidate.candidateName;
  }

  public get formalVotes(): number {
    return this._haChangePollingCandidate.formalVotes;
  }

  public get twoCandidatePref(): number | null {
    return this._haChangePollingCandidate.twoCandidatePref ?? null;
  }

  public get twoPartyPref(): number | null {
    return this._haChangePollingCandidate.twoPartyPref ?? null;
  }

}
